var map = {
	"./avatar-1.jpg": 3222,
	"./avatar-2.jpg": 5649,
	"./avatar-3.jpg": 4637,
	"./avatar-4.jpg": 4898,
	"./avatar-5.jpg": 9801,
	"./lock.png": 1429,
	"./user-1.png": 829,
	"./user-2.png": 601,
	"./user.png": 873
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5409;